<template>
  <div class="page-content setting">
    <h1 class="page-title" style="margin-bottom: 20px;">{{ $locale('sideMenu.settings.global') }}</h1>

    <el-form class="egl-elm egl-detail" :model="form" :rules="rule">
      <div class="form-module-tit">{{ $locale('setting.global.subTitle') }}</div>
      <el-form-item :label="$locale('setting.global.sendInterval')" prop="sendEmailWait">
        <el-input v-model="form.sendEmailWait" :placeholder="$locale('setting.global.placeholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$locale('setting.global.resendcount')" prop="sendEmailRetryCount">
        <el-input v-model="form.sendEmailRetryCount" :placeholder="$locale('setting.global.placeholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$locale('setting.global.emailcount')" prop="sendEmailTotal">
        <el-input v-model="form.sendEmailTotal" :placeholder="$locale('setting.global.placeholder')"></el-input>
      </el-form-item>
    </el-form>
    <hr class="dotted" />
    <div class="search-area">
      <el-row>
        <el-col :span="20">
          <div class="form-module-tit">{{ $locale('setting.ticketType') }}</div>
        </el-col>
        <el-col :span="4" class="ta-r">
          <el-button class="egl-btn-yellow" @click="toggleDialog('create')">{{$locale("global.create")}}</el-button>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" class="egl-table">
      <el-table-column prop="name" :label="$locale('global.name')" min-width="300"></el-table-column>
      <el-table-column align="center" width="120">
        <template slot="header">{{ $locale("global.control") }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <a @click="edit_fn(scope.row.id, 'edit')">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="deleteRow(scope.row.id, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="detail-page-btn">
      <!-- <el-button class="egl-btn-white" @click="cancel_fn">{{ $locale("global.cancel") }}</el-button> -->
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
    </div>
    <el-dialog
      :visible.sync="isOpen"
      width="1065px"
      :show-close="false"
      class="egl-dialog-elm channel-dialog"
      :title="$locale('setting.ticketType')"
      :before-close="closeDialogHandler"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ticketForm"
        :rules="ticketRule"
        ref="ticketTypeForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$locale('global.name')" class="long-item" prop="name">
                <el-input
                  v-model="ticketForm.name"
                  :placeholder="$locale('global.name')"
                ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="toggleDialog">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="submitForm">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGlobalSetting,
  updateGlobalSetting,
  getTicketTypeService,
  createTicketTypeService,
  updateTicketTypeService,
  deleteTicketTypeService,
  getTicketTypeDetailService,
} from "@/helpers/service/api/setting.js";
import countDownAlert from "@/utils/countDownAlert.js";
import RuleTest from "@/utils/simpleRule.js";

export default {
  name: "setting-global",
  data() {
    return {
      validity:  "",
      form: {
        sendEmailRetryCount: "",
        sendEmailTotal: "",
        sendEmailWait: "",
      },
      ticketForm: {
        ticketName: "",
      },
      rule: {
        sendEmailWait: [
          {
            required: true, message: this.$locale("setting.global.sendEmailWait.required"), trigger: "blur",
          }
        ],
        sendEmailRetryCount: [
          {
            required: true, message: this.$locale("setting.global.sendEmailRetryCount.required"), trigger: "blur",
          }
        ],
        sendEmailTotal: [
          {
            required: true, message: this.$locale("setting.global.sendEmailTotal.required"), trigger: "blur",
          }
        ],
      },
      ticketRule: {
        name: [
          {
            required: true, message: this.$locale("setting.global.ticketName.required"), trigger: "blur",
          }
        ],
      },
      tableData: [],
      isOpen: false,
      actionType: "create"
    };
  },
  methods: {
    cancel_fn() {
      this.$router.go(-1);
    },
    save_fn() {
      let obj = RuleTest(this.rule, this.form);
      if (obj.success) {
        updateGlobalSetting(obj.data).then(res => {
          if (!res.success) {
            this.$alert(res.message, {
              showClose: false,
            });
          }
        });
      }
    },
    getGlobalSetting_fn() {
      getGlobalSetting().then(res => {
        if (res.success) {
          this.form = { ...res.data };
        }
      });
    },
    getTicketTypeList() {
      getTicketTypeService({
        pageSize: 9999
      }).then(res => {
        this.tableData = res.data.data;
      });
    },
    toggleDialog(type) {
      if (type) {
        this.actionType = type;
      }
      if (this.$refs.ticketTypeForm) {
        this.$refs.ticketTypeForm.clearValidate();
      }
      this.isOpen = !this.isOpen;
    },
    closeDialogHandler() {
      this.$refs.ticketTypeForm.resetFields();
      this.ticketForm = {
        name: "",
      };
      this.toggleDialog();
    },
    submitForm() {
      this.$refs.ticketTypeForm.validate(valid => {
        if (valid) {
          if (this.actionType === "create") {
            createTicketTypeService({
              ...this.ticketForm,
              status: "active"
            }).then(() => {
              countDownAlert({ content: this.$locale("global.createSuccessfully"), callback: this.getTicketTypeList() });
              
            });
          } else {
            updateTicketTypeService({
              ...this.ticketForm
            }).then(() => {
              countDownAlert({ content: this.$locale("global.updateSuccessfully"), callback: this.getTicketTypeList() });
            });
          }
          this.closeDialogHandler();
        } else {
          return false;
        }
      });
    },
    edit_fn(id, type) {
      getTicketTypeDetailService({ id }).then(res => {
        this.ticketForm = res.data;
        this.toggleDialog(type);
      });
    },
    deleteRow(id, name) {
      // let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

      // this.$confirm(confirmHtml, "", {
      //   dangerouslyUseHTMLString: true,
      //   showClose: false,
      //   showCancelButton: true,
      //   cancelButtonClass: "egl-btn-white",
      //   cancelButtonText: this.$locale("global.cancel"),
      //   showConfirmButton: true,
      //   confirmButtonClass: "egl-btn-yellow",
      //   confirmButtonText: this.$locale("global.approve"),
      //   customClass: "egl-confirm",
      //   closeOnClickModal: false
      // })
      //   .then(() => {
      //     deleteTicketTypeService({ id }).then(() => {
      //       countDownAlert({ content: this.$locale("global.deleteSuccessfully") });
      //       this.getTicketTypeList();
      //     });
      //   });
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          deleteTicketTypeService({ id }).then(() => {
            countDownAlert({ content: this.$locale("global.deleteSuccessfully") });
            this.getTicketTypeList();
          });
        });
    },
  },
  mounted() {
    this.getGlobalSetting_fn();
    this.getTicketTypeList();
  },
};
</script>
